import { render, staticRenderFns } from "./enrollments.vue?vue&type=template&id=2b8a6eee&"
import script from "./enrollments.vue?vue&type=script&lang=js&"
export * from "./enrollments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports